import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Text } from '@daedalus/atlas/Text';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { getUser } from '@daedalus/core/src/auth/modules/selectors';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { DeleteAccountContext } from '../DeleteAccountProvider';
const SignOutWrapper = /*#__PURE__*/styled('div')({
  name: "SignOutWrapper",
  class: "s1e3655f",
  propsAsIs: false
});
export const DeleteUserProfile = () => {
  const dispatch = useDispatch();
  const {
    openModal
  } = useContext(DeleteAccountContext);
  const user = useSelector(getUser);
  const userId = user?.attributes?.sub;
  const {
    isMobile
  } = useDeviceLayout();
  const onUserDeleteClick = () => {
    openModal();
    dispatch(trackEvent({
      category: Category.System,
      entity: Entity.DeleteAccountOverlay,
      action: Action.Displayed,
      payload: {
        userId
      },
      team: Team.Retention
    }));
  };
  return <SignOutWrapper>
      <Button fullWidth={isMobile} variant="danger" size="lg" onClick={onUserDeleteClick}>
        <Text variant="labelM" colorPath="content.danger.c600">
          <FormattedMessageWrapper id="membership.deleteMyAccount" defaultMessage="Delete my account" />
        </Text>
      </Button>
    </SignOutWrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");